import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  createdRole: null,
  allRoles: [],
  allTemplates: [],
  allRoleModules: [],
  roleCompanies: [],
  roleCompanyAllSites: [],
  roleModulesPermissions: [],
  allOperations: null,
  allProductTypes: null,
  userProductTypes: [],
  allProducts: [],
  allUserProducts: [],
  allCompanies: null,
  allTeams: [],
  teamUsers: [],
  userTeams: [],
  userSites: [],
  roleCompanySites: [],
  selectedTeam: null,
  selectedRole: null,
  selectedRoleTemplate: null,
  selectedCompany: null,
  roleDetailsById: null,
  userDetailsById: null,
  allModules: [],
  allPermissions: [],
  allResourcePermissions: [],
  sitesOfCustomerAssignedToRole: [],
  allSites: null,
  resourcePermissionData: {},
  updateResourcePermissionData: {},
  updateCustomResourcePermissionData: {},
  permissionArray: [],
  error: null,
  showUserGuideDummyData: true,
  editModulePermissionsModal: false,
  roleTemplateById: null,
  permissionOfRoleTemplateById: [],
  createdRoleTemplate: null,
  isLoadingPermissionModules: false,
  permissionModules: [],
};

const rbacSlice = createSlice({
  name: 'permissions',
  initialState,
  reducers: {
    start: (state, action) => {
      state.error = null;
    },
    setReducerError: (state, action) => {
      state.error = action.payload;
    },
    setUserSites: (state, action) => {
      state.userSites = action.payload;
    },
    setAllOperations: (state, action) => {
      state.allOperations = action.payload;
    },
    setAllProductTypes: (state, action) => {
      state.allProductTypes = action.payload;
    },
    setAllCompanies: (state, action) => {
      state.allCompanies = action.payload;
    },
    setAllSites: (state, action) => {
      state.allSites = action.payload;
    },
    setUserProductTypes: (state, action) => {
      state.userProductTypes = action.payload;
    },
    setAllProducts: (state, action) => {
      state.allProducts = action.payload;
    },
    setAllUserProducts: (state, action) => {
      state.allUserProducts = action.payload;
    },
    setAllTeams: (state, action) => {
      state.allTeams = action.payload;
    },
    setSelectedTeam: (state, action) => {
      state.selectedTeam = action.payload;
    },
    setSelectedRole: (state, action) => {
      state.selectedRole = action.payload;
    },
    setSelectedRoleTemplate: (state, action) => {
      state.selectedRoleTemplate = action.payload;
    },
    setRoleDetailsById: (state, action) => {
      state.roleDetailsById = action.payload;
    },
    setUserDetailsById: (state, action) => {
      state.userDetailsById = action.payload;
    },
    setAllRoles: (state, action) => {
      state.allRoles = action.payload;
    },
    setAllModules: (state, action) => {
      state.allModules = action.payload;
    },
    setAllPermissions: (state, action) => {
      state.allPermissions = action.payload;
    },
    setCreatedRole: (state, action) => {
      state.createdRole = action.payload;
    },
    setAllRoleModules: (state, action) => {
      state.allRoleModules = action.payload;
    },
    setRoleModulesPermissions: (state, action) => {
      state.roleModulesPermissions = action.payload;
    },
    setRoleCompanies: (state, action) => {
      state.roleCompanies = action.payload;
    },
    setTeamUsers: (state, action) => {
      state.teamUsers = action.payload;
    },
    setSelectedCompany: (state, action) => {
      state.selectedCompany = action.payload;
    },
    setRoleCompanySites: (state, action) => {
      state.roleCompanySites = action.payload;
    },
    setRoleCompanyAllSites: (state, action) => {
      state.roleCompanyAllSites = action.payload;
    },
    setSitesOfCustomerAssignedToRole: (state, action) => {
      state.sitesOfCustomerAssignedToRole = action.payload;
    },
    setAllResourcePermissions: (state, action) => {
      state.allResourcePermissions = action.payload;
    },
    setUserTeams: (state, action) => {
      state.userTeams = action.payload;
    },
    setResourcePermissionData: (state, action) => {
      state.resourcePermissionData = action.payload;
    },
    setUpdateResourcePermissionData: (state, action) => {
      state.updateResourcePermissionData = action.payload;
    },
    setUpdateCustomResourcePermissionData: (state, action) => {
      state.updateCustomResourcePermissionData = action.payload;
    },
    setPermissionArray: (state, action) => {
      state.permissionArray = action.payload;
    },
    setShowUserGuideDummyData: (state, action) => {
      state.showUserGuideDummyData = action.payload;
    },
    toggleEditModulePermissionsModal: (state, action) => {
      state.editModulePermissionsModal = !state.editModulePermissionsModal;
    },
    setResetRbac: () => {
      return initialState;
    },
    setAllTemplates: (state, action) => {
      state.allTemplates = action.payload;
    },
    setRoleTemplateById: (state, action) => {
      state.roleTemplateById = action.payload;
    },
    setPermissionOfRoleTemplateById: (state, action) => {
      state.permissionOfRoleTemplateById = action.payload;
    },
    setCreatedRoleTemplate: (state, action) => {
      state.createdRoleTemplate = action.payload;
    },
    setPermissionModules: (state, action) => {
      state.permissionModules = action.payload;
      state.isLoadingPermissionModules = false;
    },
    startLoadingPermissionModules: (state, action) => {
      state.isLoadingPermissionModules = true;
    },
    stopLoadingPermissionModules: (state, action) => {
      state.isLoadingPermissionModules = false;
    },
  },
});

export const {
  start,
  setReducerError,
  setAllResourcePermissions,
  setCreatedRole,
  setUserTeams,
  setUserSites,
  setRoleCompanyAllSites,
  setSitesOfCustomerAssignedToRole,
  setRoleCompanySites,
  setTeamUsers,
  setRoleCompanies,
  setSelectedCompany,
  setRoleModulesPermissions,
  setAllRoles,
  setAllRoleModules,
  setAllModules,
  setAllPermissions,
  setRoleDetailsById,
  setUserDetailsById,
  setAllOperations,
  setAllProductTypes,
  setAllCompanies,
  setAllSites,
  setUserProductTypes,
  setAllProducts,
  setAllUserProducts,
  setAllTeams,
  setSelectedTeam,
  setSelectedRole,
  setSelectedRoleTemplate,
  setResourcePermissionData,
  setUpdateResourcePermissionData,
  setUpdateCustomResourcePermissionData,
  setPermissionArray,
  setResetRbac,
  setShowUserGuideDummyData,
  toggleEditModulePermissionsModal,
  setAllTemplates,
  setRoleTemplateById,
  setPermissionOfRoleTemplateById,
  setCreatedRoleTemplate,
  setPermissionModules,
  startLoadingPermissionModules,
  stopLoadingPermissionModules,
} = rbacSlice.actions;

export default rbacSlice.reducer;
